var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('poplist',{staticClass:"omni-button button"},[_c('template',{slot:"fuze"},[_vm._v(_vm._s(_vm.currentButton)),_c('i',{staticClass:"icon-downArrow"})]),_vm._v(" "),_c('itemlist',_vm._l((_vm.buttonlist),function(button,key){return _c('li',{on:{"click":function($event){return _vm.handleClick(key, button)}}},[_vm._v(_vm._s(button))])}),0)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aa80503","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uButton/omniButton.vue
// module id = cW49
// module chunks = 29